<footer class="main-footer">
    Potenciado por <strong>{{ entidad }}</strong>
    <div class="float-right d-none d-sm-inline-block"><b>Version</b> {{ version }}</div>
</footer>